module.exports = __webpack_public_path__ + "img/Colonoscopy.df919867.png";